import { AdvancedSelectComponent, AdvancedSubHeaderComponent, MultiEntryTextFieldComponent } from '@vivli/shared/components';
import { CSSProperties } from 'react';
import { useOrganizations } from '@vivli/features/organizations/infrastructure/hook';
import { ISelectOption } from '@vivli/features/search/infrastructure/interface';

const metricsExportStyle: CSSProperties = {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    columnGap: '10px',
    alignItems: 'end',
};

export const MetricsReportFilterComponent = ({ setDataRequestIds, handleContributorChanged }) => {
    const { organizations } = useOrganizations();
    const allOption = { value: 'all', label: '---' } as ISelectOption;

    const alphabeticalSort = (a, b) => {
        return a.title < b.title ? -1 : 1;
    };
    let organizationsOptions = organizations
        ?.map(
            (org) =>
                ({
                    label: org.name,
                    value: org.id,
                } as ISelectOption)
        )
        .sort(alphabeticalSort);

    organizationsOptions?.unshift(allOption);

    return (
        <>
            <div style={{ width: '100%' }}>
                <div style={{ fontWeight: 'bold' }}>Metrics Export Filters</div>
                <div style={metricsExportStyle}>
                    <div>
                        <AdvancedSubHeaderComponent title={'Data Contributor (Select to Refresh Metrics)'} />
                        <AdvancedSelectComponent
                            dataId={'metricsReportDataContributor'}
                            targetStyle={{ backgroundColor: 'white' }}
                            isMulti={false}
                            isSearchable={true}
                            sort={'asc'}
                            onChange={handleContributorChanged}
                            options={organizationsOptions}
                        />
                    </div>

                    <MultiEntryTextFieldComponent
                        textDivStyle={{ height: '100%' }}
                        label={'Data Request IDs (Press Enter to Add)'}
                        onChange={setDataRequestIds}
                        bubblePlacement={'top'}
                    />
                </div>
            </div>
        </>
    );
};
